import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { EventParentCategory }   from 'Domain/Models';

const config = {
    model: EventParentCategory,
    baseRoute: '/admin/event-parent-category',
    singular: 'eventParentCategory',
    plural: 'eventParentCategories',
}

class EventParentCategoryRepository extends BaseRepository<EventParentCategory, typeof config.singular, typeof config.plural> {

}

export default new EventParentCategoryRepository(config);
